import InfographicBlock from "./page-components/infographic-block";
import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";

const TextStyles = styled.div`
  a {
    ${tw`text-blue-500 cursor-pointer underline hover:text-blue-600`}
  }
  .body-text p {
    ${tw`text-sm md:text-lg mb-4 md:mb-6`}
  }
`;

const InfographicBlockGroup = (props) => {
  const { _rawBody, title, infographicBlocks } =
    props.props ?? props.pageBlockGroup;

  return (
    <section className="py-10 md:py-16 bg-gradient">
      {(_rawBody || title) && (
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-wrap">
            <div className="md:w-10/12 mx-auto">
              {title && (
                <>
                  <hr className="w-8 border-yellow-500 border-4 mb-2" />
                  <h2 className="text-blue-500 font-bold tracking-tighter text-xl md:text-4xl mb-1 md:mb-3 leading-none">
                    {title}
                  </h2>
                </>
              )}
              {_rawBody && (
                <TextStyles>
                  <div className="body-text">
                    <BlockText blocks={_rawBody} />
                  </div>
                </TextStyles>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="max-w-7xl px-4 mx-auto">
        <div className="flex flex-wrap justify-center w-full">
          <ul className="mb-6 md:flex md:flex-wrap md:-mx-4 justify-center w-full">
            {infographicBlocks &&
              infographicBlocks.map((data, index) => (
                <li key={index} className="md:w-3/12 md:px-4 md:flex mb-2">
                  <InfographicBlock {...data} section={props?.section}/>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default InfographicBlockGroup;
